module.exports = __webpack_public_path__ + "img/STEngineering_2.c30f7afb.png";